<br><br>
<div class="container px-4  px-md-0">
    <div class="row trails align-items-center">
        <div class="col-12 col-md-7">
            <div class="header-content ">
                <h3 class="title my-2">
                    {{ "interview_start_instructions" | translate }}
                </h3>

            </div>



        </div>

        <div class="col-md-5 col-12">
            <img src="../../../../../assets/img/trails-head.png" class="w-100" alt="trails-head">
        </div>
    </div>

    <section class="mt-5">
        <div class="card">
            <div class="card-header py-3">
                {{ "vrTrails.guidelines" | translate }}
            </div>
            <div class="card-body d-flex p-2">
                <div class="card-left p-2 col-12 col-md-6">
                    <h6>{{ "vrTrails.steps" | translate }}</h6>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class="bi bi-chat"></i>
                            </div>
                            <p>{{ "vrTrails.stepAsk" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-headphones"></i>
                            </div>
                            <p>{{ "vrTrails.stepListen" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-lightbulb"></i>
                            </div>
                            <p>{{ "vrTrails.stepThink" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-mic-fill"></i>
                            </div>
                            <p>{{ "vrTrails.stepRecord" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-check2-square"></i>
                            </div>
                            <p>{{ "vrTrails.stepReview" | translate }}</p>
                        </li>
                    </ul>
                </div>
                <div class="card-right p-2 col-12 col-md-6">
                    <h6>{{ "vrTrails.rules" | translate }}</h6>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class="bi bi-camera-video"></i>
                            </div>
                            <p>{{ "vrTrails.ruleCamera" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-volume-off"></i>
                            </div>
                            <p>{{ "vrTrails.ruleSpeak" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-clock"></i>
                            </div>
                            <p>{{ "vrTrails.ruleAnswerTime" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-alarm"></i>
                            </div>
                            <p>{{ "vrTrails.ruleSessionTime" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-info-circle"></i>
                            </div>
                            <p>{{ "vrTrails.ruleChances" | translate }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <div class="start-section mt-5">
        <h3 class="section-title">{{ "VrCompany.startSection.title" | translate }}</h3>

        <p class="section-text">{{ "VrCompany.startSection.description" | translate }}</p>

        <button class="gradient-button" (click)="startInterview()">
            {{ "VrCompany.startSection.startButton" | translate }}
        </button>
    </div>
</div>